import { SelfTestQuestion, SelfTestQuestionCollection } from "../../../../components/self-test/model/SelfTestQuestion";
import { result } from "./result";

export const questions: SelfTestQuestionCollection = {
    showProgressBarAfterIndex: 0,
    analytics: {
        slug: 'hpylori',
        resultText: (answers) => {
            const r =  result(answers);
            return `risk-${r.risk ? 'high' : 'low'}`;
        },
    },
    questions: [
        {
            type: 'description',
            label: '開始',
            title: '我有<span class="highlight">幽門螺旋桿菌</span>嗎？',
            content: '只需回答5條簡單選擇題，就可了解自己感染幽門螺旋桿菌的風險。',
            image: 'patient-care/h-pylori/intro_792x680.png',
            answers: [
                {
                    label: "有",
                    answer: "yes",
                },
                {
                    label: "沒有",
                    answer: "no",
                }
            ]
        },
        {
            type: 'multiple-choice',
            label: '第一題',
            title: '您有胃痛、上腹痛等問題嗎？',
            content: '（胃痛及上腹痛是感染幽門螺旋桿菌後最常見的症狀，通常發生在空腹時或兩餐之間，並持續幾分鐘，甚至幾小時<sup>13</sup>。）',
            image: 'patient-care/h-pylori/q1_608x567.png',
            answers: [
                {
                    label: "有",
                    answer: "yes",
                },
                {
                    label: "沒有",
                    answer: "no",
                }
            ]
        },
        {
            type: 'multiple-choice',
            label: '第二題',
            title: '您有噁心、嘔吐或食慾不振等問題嗎？',
            content: '（感染幽門螺旋桿菌後會出現胃潰瘍，而噁心、嘔吐或食慾不振屬於不常見的潰瘍症狀<sup>13</sup>。）',
            image: 'patient-care/h-pylori/q2_792x680.png',
            answers: [
                {
                    label: "有",
                    answer: "yes",
                },
                {
                    label: "沒有",
                    answer: "no",
                }
            ]
        },
        {
            type: 'multiple-choice',
            label: '第三題',
            title: '您有試過吐血、大便出血嗎？',
            image: 'patient-care/h-pylori/q3_792x680.png',
            answers: [
                {
                    label: "有",
                    answer: "yes",
                },
                {
                    label: "沒有",
                    answer: "no",
                }
            ]
        },
        {
            type: 'multiple-choice',
            label: '第四題',
            title: '您有貧血嗎？',
            content: '（感染幽門螺旋桿菌後可能發生出血情況，長期出血更可能引致貧血問題<sup>13</sup>。）',
            image: 'patient-care/h-pylori/q4_684x645.png',
            answers: [
                {
                    label: "有",
                    answer: "yes",
                },
                {
                    label: "沒有",
                    answer: "no",
                }
            ]
        },
        {
            type: 'multiple-choice',
            label: '第五題',
            title: '您家人或伴侶曾/正感染幽門螺旋桿菌嗎？',
            content: '（幽門螺旋桿菌有機會於家庭內傳播。如果有其中一個家庭成員確診感染，他／她的伴侶會有68%機會同時受到感染，而子女則會有40%機會同時受感染<sup>5</sup>。）',
            image: 'patient-care/h-pylori/q5_792x680.png',
            answers: [
                {
                    label: "有",
                    answer: "yes",
                },
                {
                    label: "沒有",
                    answer: "no",
                }
            ]
        },
    ]
};
